import { useState, useEffect } from "react";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { convertToRaw, EditorState, ContentState, convertFromHTML } from "draft-js";
import draftToHtml from "draftjs-to-html";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

export default function BookingWysiwyg({ ...props }) {
    const [editorState, setEditorState] = useState(
        EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(props.value)))
    );

    const { chatTags = [] } = useSelector((state) => state.chatTags || {});

    useEffect(() => {
        setEditorState(
            EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(props.value)))
        );
    }, [props.value]);

    const staff_list = (props.staff || []).map((staff) => ({
        text: staff.name,
        value: staff.name,
        url: String(staff.id),
        type: 'staff',
    }));

    // Add chat tags to the mention list
    const tag_list = (chatTags || [])
        .filter(tag => tag.active)
        .map((tag) => ({
            text: tag.name,
            value: tag.name,
            url: String(tag.id),
            type: 'tag',
        }));

    // Combine staff and tags
    const mention_list = [...staff_list, ...tag_list];

    const onEditorStateChange = (newEditorState) => {
        // Get the current content and selection
        const content = newEditorState.getCurrentContent();
        const selection = newEditorState.getSelection();
        const block = content.getBlockForKey(selection.getStartKey());
        const text = block.getText();

        // Check if we just typed a space
        if (selection.getStartOffset() > 0 && text[selection.getStartOffset() - 1] === ' ') {
            // Look for @ pattern in the text before the space
            const textBeforeSpace = text.slice(0, selection.getStartOffset() - 1);
            const matches = textBeforeSpace.match(/@(\w+)$/);

            if (matches) {
                const mentionText = matches[1];
                // Find if this matches any staff member or tag
                const matchedMention = mention_list.find(
                    item => item.text.toLowerCase() === mentionText.toLowerCase()
                );

                if (matchedMention) {
                    // Auto-select the mention
                    // The mention will be properly formatted by the editor
                } else {
                    toast.error(`Invalid mention: ${mentionText}. Please select from the suggestions.`, {
                        duration: 3000,
                        position: 'bottom-right',
                    });
                }
            }
        }

        setEditorState(newEditorState);
    };

    const onBlur = () => {
        const forFormik = draftToHtml(convertToRaw(editorState.getCurrentContent()));
        props.setFieldValue("message", forFormik);
    };

    return (
        <Editor
            mention={{
                separator: " ",
                trigger: "@",
                suggestions: mention_list,
                // Enforce suggestions to be selected
                suggestionsPortalHost: document.body,
                mentionComponent: (mention) => (
                    <span 
                        className="mention" 
                        data-staff-id={mention.type === 'staff' ? mention.url : undefined}
                        data-tag-id={mention.type === 'tag' ? mention.url : undefined}
                        data-mention-type={mention.type}
                    >
                        @{mention.text}
                    </span>
                ),
            }}
            hashtag={{}}
            {...props}
            onEditorStateChange={onEditorStateChange}
            editorClassName="px-2 py-2 block w-full sm:text-sm !outline-none resize-none bg-light_background h-full"
            wrapperClassName="bg-light_background"
            editorState={editorState}
            onBlur={onBlur}
            toolbar={{
                options: ["inline", "blockType", "fontSize", "list", "textAlign", "colorPicker", "link"],
                inline: { inDropdown: true },
                list: { inDropdown: true },
                textAlign: { inDropdown: true },
                link: { inDropdown: true },
                emoji: false,
            }}
        />
    );
}